module.exports = __webpack_public_path__ + "img/202407_06.60d189ae.jpg";